import { TenantName } from '@packlink/packlink-sdk';

const getCheckoutTenantName = () => {
  var _window;
  // packlink-com SSR, window is not available in build time
  if (typeof window === 'undefined') {
    return TenantName.PACKLINK;
  }
  const hostname = ((_window = window) === null || _window === void 0 ? void 0 : _window.location.hostname) || '';
  if (hostname.includes('packlink') || hostname.includes('checkout') || hostname.includes('global')) {
    if (hostname.includes('.es') || hostname.includes('es-')) {
      return TenantName.PACKLINKES;
    }
    if (hostname.includes('.it') || hostname.includes('it-')) {
      return TenantName.PACKLINKIT;
    }
    return TenantName.PACKLINK;
  }
  if (hostname.includes('dpd')) {
    return TenantName.DPDCBEUN;
  }
  return null;
};

export { getCheckoutTenantName };
//# sourceMappingURL=checkout.js.map
